if (window.innerWidth < 1200) {
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.wls-trust-bar__slider').forEach(slider => {

            if (slider.closest('wls-trust-bar')?.classList.contains('has-trust-points')) return;

            var productCards = new Splide(slider, {
                type: 'loop',
                perPage: 3,
                autoScroll: {
                  speed: 0.4,
                  pauseOnHover: true,
                  pauseOnFocus: true,
                },
                gap: 16,
                pagination: false,
                arrows: false,
                breakpoints: {
                    767: {
                        perPage: 2,
                    }
                },
            });

            productCards.mount(window.splide.Extensions);
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.wls-trust-bar__slider').forEach(slider => {

        if (slider.closest('wls-trust-bar')?.classList.contains('has-trust-points')) return;

        const slidesCount = slider.querySelectorAll('.splide__slide').length;

        if (window.innerWidth > 1400 && slidesCount >= 7) {
            new Splide(slider, {
                type: 'loop',
                autoScroll: {
                  speed: 0.4,
                  pauseOnHover: true,
                  pauseOnFocus: true,
                },
                perPage: 5,
                gap: 16,
                pagination: false,
                arrows: false,
            }).mount(window.splide.Extensions);
        }

        if (window.innerWidth > 1199 && window.innerWidth < 1400 && slidesCount >= 5) {
            new Splide(slider, {
                type: 'loop',
                autoScroll: {
                  speed: 0.4,
                  pauseOnHover: true,
                  pauseOnFocus: true,
                },
                perPage: 4,
                gap: 16,
                pagination: false,
                arrows: false,
            }).mount(window.splide.Extensions);
        }
    });
});